__turbopack_context__.v({
  "BlogTile": "BlogTile-module-sass-module__gud5fa__BlogTile",
  "Category": "BlogTile-module-sass-module__gud5fa__Category",
  "Content": "BlogTile-module-sass-module__gud5fa__Content",
  "Excerpt": "BlogTile-module-sass-module__gud5fa__Excerpt",
  "Image": "BlogTile-module-sass-module__gud5fa__Image",
  "Link": "BlogTile-module-sass-module__gud5fa__Link",
  "Title": "BlogTile-module-sass-module__gud5fa__Title",
});
